import React, { Component } from "react";
import { connect } from "react-redux";
import "./styles.scss";
import { Scrollbars } from "react-custom-scrollbars";
import * as actionTypes from "../../../../../store/actions/types";
import { Spin } from "antd";
import { userDetails, userLogOut } from "../../../../../utils";
import {
  getAdminUser,
  getPendingPaymentsByUserId,
  getSessionValidateStatus,
} from "../../../../../api";
import { Button, PaymentOfferCard } from "../../../../../components";
import { v4 as uuidv4 } from "uuid";
import { GetIcon } from "../../../../../config/icon";

class pending extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewPointWidth: 0,
      viewPointHeight: 0,
      isActiveShadow: false,
      isLoading: false,
      dataSource: [],
      pendingOffers: [],
      acceptedOffers: [],
      rejectedOffers: [],
      userDataSource: [],
      categoryOptions: [],
      pageNo: 1,
      pendingPageNo: 1,
      rejectPageNo: 1,
      acceptedTotalCount: 0,
      pendingTotalCount: 0,
      rejectedTotalCount: 0,
      pageViewCount: 10,
      selectPaymentOffers: [],
      pendingPaymentAmount: 0,
      pendingPaymentCount: 0,
      dataForm: {
        searchOffer: {
          key: "searchOffer",
          elementType: "input",
          elementConfig: {
            type: "text",
            placeholder: "Search offer title here...",
          },
          value: "",
          validation: {
            required: false,
          },
          valid: false,
          touched: false,
          label: "",
        },
        keywords: {
          key: "keywords",
          elementType: "select",
          elementConfig: {
            type: "text",
            placeholder: "Search Merchant here...",
            options: [],
          },
          value: "",
          validation: {
            required: true,
          },
          valid: false,
          touched: false,
          label: "",
        },
      },
      tabJson: [
        {
          id: uuidv4(),
          key: 1,
          tabName: "Pending Offers",
          content: "",
        },
        {
          id: uuidv4(),
          key: 2,
          tabName: "Active Offers",
          content: "",
        },
        {
          id: uuidv4(),
          key: 3,
          tabName: "Rejected Offers",
          content: "",
        },
      ],
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  updateWindowDimensions() {
    this.setState({
      viewPointWidth: window.innerWidth,
      viewPointHeight: window.innerHeight,
    });
    //window.removeEventListener('scroll', this.handleOnScroll);
  }

  handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };

  async componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    window.addEventListener("scroll", this.handleOnScroll);

    await this.getAll(this.props.startDate, this.props.endDate);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleOnScroll);
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  inputHandleChange = (event, inputIdentity) => {
    let val = null;
    const updateForm = {
      ...this.state.dataForm,
    };
    const updatedFormElement = {
      ...updateForm[inputIdentity],
    };
    //updatedFormElement.touched = true;
    updateForm[inputIdentity] = updatedFormElement;
    updatedFormElement.value = event.target.value;
    let formIsValid = true;
    for (let inputIdentifier in updateForm) {
      formIsValid = updateForm[inputIdentifier].valid && formIsValid;
    }
    this.setState({ dataForm: updateForm, formIsValid: formIsValid });
  };

  // async getAll() {
  //   this.setState({ isLoading: true });
  //   let res = await getOffer();

  //   const offersData = res && res.data;
  //   console.log({ res });
  //   let newData = null;
  //   let indices = null;
  //   if (offersData) {
  //     indices = offersData.map((_, index) => index);

  //     indices.sort((a, b) => b - a);
  //   }

  //   newData = indices.map((index) => offersData[index]);
  //   this.setState({
  //     dataSource: newData,
  //     isLoading: false,
  //   });
  // }

  async getAll(startData, endDate) {
    let sessionStatus = await getSessionValidateStatus();
    if (sessionStatus?.data?.status) {
      this.setState({ isLoading: true });
      // let user = await userDetails();
      let user = this.props.selectPaymentOffer;
      if (user && user.userId) {
        let resUser = await getAdminUser();

        let resPayments = await getPendingPaymentsByUserId(
          user?.userId,
          "pending",
          startData,
          endDate,
        );
        console.log("resPayments:::", resPayments);

        this.setState({
          // dataSource: newData,
          pendingPaymentAmount: resPayments?.data?.totalPendingAmount,
          pendingPaymentCount: resPayments?.data?.pendingPaymentCount,
          pendingOffers: resPayments?.data?.offers,
          userDataSource: resUser && resUser.data,
          isLoading: false,
        });
        this.props.setCount(resPayments?.data?.offers?.length);
      }
    } else {
      userLogOut();
      this.props.history.push("/sign-in");
    }
  }

  pushPendingItems = async () => {
    const acceptedItems = this.state.dataSource
      .filter((item) => item.status === "new")
      .slice(0, 10);
    this.setState((prevState) => ({
      pendingOffers: [...prevState.pendingOffers, ...acceptedItems],
      pendingPageNo: prevState.pendingPageNo + 1,
    }));
  };

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.refreshOffers !== this.props.refreshOffers) {
      this.setState({ isLoading: true });
      await this.getAll(this.props.startDate, this.props.endDate);
      if (!this.state.isLoading) {
        this.setState({ selectPaymentOffers: [] });
        this.props.doneRefresh();
      }
    }
    if (
      prevProps.startDate !== this.props.startDate ||
      prevProps.endDate !== this.props.endDate
    ) {
      await this.getAll(this.props.startDate, this.props.endDate);
    }
    if (prevProps.selectAll !== this.props.selectAll) {
      if (this.props.selectAll) {
        this.setState((prevState) => {
          const { selectPaymentOffers } = prevState;

          const updatedOffers = this.state.pendingOffers?.map((x) => x.offerId);
          console.log({ updatedOffers });
          return {
            selectPaymentOffers: updatedOffers,
          };
        });
      } else {
        this.setState({
          selectPaymentOffers: [],
        });
      }
    }
  }
  onSelectPaymentOffer = (i) => {
    this.setState((prevState) => {
      const { selectPaymentOffers } = prevState;
      console.log(selectPaymentOffers.includes(i));

      const updatedOffers = selectPaymentOffers.includes(i)
        ? selectPaymentOffers.filter((item) => item !== i) // Remove
        : [...selectPaymentOffers, i]; // Add

      return {
        selectPaymentOffers: updatedOffers,
      };
    });
  };

  render() {
    const {
      dataSource,
      viewPointHeight,
      pendingOffers,
      isLoading,
      selectPaymentOffers,
      dataForm,
    } = this.state;
    const {} = this.props;

    return (
      <>
        <div>
          {isLoading && (
            <div style={{ margin: "10% 50%" }}>
              <Spin size="large" spinning={isLoading} />
            </div>
          )}
          {!isLoading && (
            <>
              {/* Pending offers */}
              <div>
                <Scrollbars
                  style={{ height: viewPointHeight - 330 }}
                  thumbMinSize={30}
                  universal={true}
                  autoHide
                >
                  {pendingOffers && pendingOffers.length > 0 && (
                    <>
                      {pendingOffers
                        .filter((item) => {
                          if (dataForm.searchOffer.value === "") {
                            return item; // Corrected the return statement
                          } else if (
                            item.header
                              ?.toLowerCase()
                              .includes(
                                dataForm.searchOffer.value.toLowerCase(),
                              )
                          ) {
                            return item; // Corrected the return statement
                          }
                        })
                        .map((item, index) => (
                          <PaymentOfferCard
                            details={item && item.header}
                            name={
                              item &&
                              item.merchant &&
                              item.merchant.merchantName
                            }
                            bankName={item && item.bank && item.bank.bankName}
                            logo={item && item.bank && item.bank.logoURL}
                            imgUrl={item.bannerImageURL}
                            userName={item && item?.user?.firstName}
                            userId={item && item?.user?.userId}
                            createAt={item && item.createdAt}
                            status={
                              item &&
                              item?.status?.charAt(0).toUpperCase() +
                                item?.status?.slice(1)
                            }
                            isSelect={selectPaymentOffers.includes(
                              item.offerId,
                            )}
                            onClickSelectOffer={() =>
                              this.onSelectPaymentOffer(item?.offerId)
                            }
                            onClickViewOffer={
                              () =>
                                // {
                                this.props.onClickOpenOfferView(item)
                              //   this.props.onClickClosePayment();
                              // }
                            }
                          />
                        ))}
                    </>
                  )}
                  {!isLoading &&
                    this.state.pendingTotalCount -
                      this.state.pendingPageNo * this.state.pageViewCount >
                      0 && (
                      <div
                        className={
                          "console__load-more-wrp d-flex justify-content-center mt-3"
                        }
                      >
                        <Button
                          size={"sm"}
                          type={"btn-primary light"}
                          isLoading={isLoading}
                          onClick={async () => {
                            if (dataSource?.length > 0) {
                              await this.pushPendingItems();
                            }
                          }}
                          text={`Load more offers (${
                            this.state.pendingTotalCount -
                            this.state.pendingPageNo * this.state.pageViewCount
                          })`}
                        />
                      </div>
                    )}
                  {this.state.isLoading && (
                    <div style={{ margin: "0 50%", opacity: 0.5 }}>
                      <Spin size="large" spinning={isLoading} />
                    </div>
                  )}
                </Scrollbars>
                <div
                  className={
                    "cco__total-pending d-flex flex-row justify-content-between align-items-center"
                  }
                >
                  <div className={"d-flex flex-column"}>
                    <div className={"cco__tp-title"}>Total Amount Due</div>
                    <div className={"cco__tp-amount d-flex"}>
                      {"LKR " + this.state.pendingPaymentAmount?.toFixed(2)}
                    </div>
                  </div>
                  <div className={"d-flex flex-row align-items-center"}>
                    <div className={"cco__tp-rows d-flex"}>
                      Selected rows : {selectPaymentOffers?.length}
                    </div>
                    <div className={"cco__tp-action"}>
                      <Button
                        leftIcon={false}
                        rightIcon={false}
                        isLoading={isLoading}
                        isActiveAnimation={false}
                        reactRightIcon={GetIcon("leftArrow")}
                        onClick={async () =>
                          this.props.onClickOpenPaymentDetails({
                            offers: selectPaymentOffers,
                            userID: this.props.selectPaymentOffer,
                          })
                        }
                        text={"Paid"}
                        size={"sm-x"}
                        type={"btn-block"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userData: state.userReducer.userData,
  refreshOffers: state.offerReducer.refreshOffers,
  selectPaymentOffer: state.paymentReducer.selectPaymentOffer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    onClickClearSelected: () =>
      dispatch({ type: actionTypes.CLEAR_OFFER_DETAILS }),
    onClickSelectOffer: (data) =>
      dispatch({ type: actionTypes.VIEW_OFFER_DETAILS, payload: data }),
    onClickOpenOfferView: (payload) =>
      dispatch({
        type: actionTypes.OPEN_OFFER_VIEW_MODAL,
        payload: payload,
      }),
    onClickClosePayment: () =>
      dispatch({ type: actionTypes.CLOSE_PAYMENT_MODAL, status: false }),
    onClickSelectedMerchant: (payload) =>
      dispatch({ type: actionTypes.SELECTED_SEARCH_MERCHANT_MODAL, payload }),

    doneRefresh: () =>
      dispatch({
        type: actionTypes.DONE_REFRESH_OFFERS,
      }),
    onClickOpenPaymentDetails: (payload) =>
      dispatch({
        type: actionTypes.OPEN_PAYMENT_DETAILS_MODAL,
        payload: payload,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(pending);
